
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulicPipe06 as ObiHydraulicPipe06Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-pipe-06.js';
 
 
 

 
 export const ObiHydraulicPipe06 = createComponent({
   react: React,
   tagName: 'obi-hydraulic-pipe-06',
   elementClass: ObiHydraulicPipe06Element,
   events: {
     
   }
  });
 
 